export class MPARequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "operation",
            "baseName": "operation",
            "type": "MPAOperationType",
            "format": ""
        },
        {
            "name": "entityType",
            "baseName": "entityType",
            "type": "MPAEntityType",
            "format": ""
        },
        {
            "name": "requestMethod",
            "baseName": "requestMethod",
            "type": "string",
            "format": ""
        },
        {
            "name": "requestPath",
            "baseName": "requestPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "requestBody",
            "baseName": "requestBody",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourcePrincipal",
            "baseName": "sourcePrincipal",
            "type": "MPAPrincipal",
            "format": ""
        },
        {
            "name": "targetPrincipal",
            "baseName": "targetPrincipal",
            "type": "MPAPrincipal",
            "format": ""
        },
        {
            "name": "resourceIds",
            "baseName": "resourceIds",
            "type": "Array<string>",
            "format": "uuid"
        },
        {
            "name": "requesterId",
            "baseName": "requesterId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "requesterEmail",
            "baseName": "requesterEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "requesterName",
            "baseName": "requesterName",
            "type": "string",
            "format": ""
        },
        {
            "name": "comment",
            "baseName": "comment",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "MPARequestStatus",
            "format": ""
        },
        {
            "name": "policyDetails",
            "baseName": "policyDetails",
            "type": "Array<MPARequestPolicyDetail>",
            "format": ""
        },
        {
            "name": "approvalExpirationTime",
            "baseName": "approvalExpirationTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "executionExpirationTime",
            "baseName": "executionExpirationTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "resolvedTime",
            "baseName": "resolvedTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "createdTime",
            "baseName": "createdTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "resourceStateBefore",
            "baseName": "resourceStateBefore",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceStateAfter",
            "baseName": "resourceStateAfter",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MPARequest.attributeTypeMap;
    }
    constructor() {
    }
}
